var $ = require('jquery');
require('bootstrap');
require('jquery-countto');
var OnScreen = require('onscreen');
var os = new OnScreen({
    tolerance: 0,
    debounce: 100
});

$(function() {

    //Resize logo on scroll
    /*
    window.onscroll = function() {
        resizeLogo()
    };

    function resizeLogo() {
        var Logo = document.getElementById("logo")
        if (document.body.scrollTop > 5 || document.documentElement.scrollTop > 5) {
            Logo.style.width = '200px';
        } else {
            Logo.style.width = '325px';
        }
    }
    */


    //Counter
    $('.count').each(function () {
        var totalcount = Number($(this).html());
        $(this)
            .html('0')
            .data('count',totalcount)
            .data('counted',false);
    });
    os.on('enter', '.count', function(element, event){
        if( !Boolean($(element).data('counted')) ) {
            $(element)
                .countTo({
                    from: 0,
                    to: Number($(element).data('count')),
                    speed: 1500
                })
                .data('counted', true);
        }
    });

});